module.exports = __webpack_public_path__ + "media/packs/site/assets/images/fr/fr_section03_img02-c548e6bd6c746fa3f94b056cb723da53.png";